import { Button } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceEditorVersion } from '@features/invoices/enums/invoiceEditorVersion'

import { useZervantNavigation } from '../../../../../../../../hooks'
import { useInvoice } from '../../../../contexts/invoiceContext'
import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'

export const ExternalViewInvoiceButton = () => {
  const { t } = useTranslation()
  const { trackInvoiceView } = useTrackInvoiceView()
  const { invoiceId, invoice } = useInvoice()
  const { redirectToZervantInvoiceView } = useZervantNavigation()

  const handleButtonClick = useCallback(() => {
    trackInvoiceView('Access invoice view in Zervant clicked')
    redirectToZervantInvoiceView(invoiceId)
  }, [invoiceId, redirectToZervantInvoiceView, trackInvoiceView])

  if (!invoice || invoice.version === InvoiceEditorVersion.Ageras) {
    return null
  }

  return (
    <Button onClick={handleButtonClick} variant="outlined">
      {t('external_invoices.open_zervant_invoice_button.cta')}
    </Button>
  )
}
